<template>
    <div class="lato">
        <div id="details" class="notes">
            <h5 class="mt-3" v-if="candidate.staffType == 'Senior Non-academic'"><b>FORM AAF/A.F.</b></h5>
            <h5 class="mt-3" v-if="candidate.staffType == 'Junior Non-academic'"><b>FORM JSA/IIS</b></h5>
            <h5 class="px-5"><b>APPRAISAL ASSESSMENT FORM</b></h5>
            <h6 v-if="candidate.staffType == 'Senior Non-academic'" class="px-2"><b>SENIOR NON-ACADEMIC STAFF (CONTISS 6 - 15)</b></h6>
            <h6 v-if="candidate.staffType == 'Junior Non-academic'" class="px-5"><b>JUNIOR NON-ACADEMMIC STAFF (CONTISS 1 - 5)</b></h6>
        </div>
        <div class="container my-4 pe-5 d-flex flex-wrap">
            <div class="mb-3 me-5">
                <div class="mb-2">
                    <p class="mb-0"><b>NAME OF STAFF:</b></p>
                </div>
                <div>
                    {{ candidate.name }}
                </div>
            </div>
            <div class="mb-3 me-5">
                <div class="ms-4 mb-2">
                    <p class="mb-0"><b>DEPARTMENT/UNIT:</b></p>
                </div>
                <div class="ms-4">
                    {{ candidate.department }}
                </div>
            </div>
            <div class="mb-3 me-5">
                <div style="margin-bottom: -20px;">
                    <p><b>CATEGORY OF STAFF:</b></p>
                </div>
                <div>
                    <div>
                        <select v-if="candidate.staffType == 'Senior Non-academic'" id="staffCadre" name="staffCadre" v-model="candidate.staffCadre"
                            style="width: 320px;" disabled>
                            <option value="Registry" selected>Registry - Administrative Officers Cadre</option>
                            <option value="Executive">Executive Officers Cadre</option>
                            <option value="Sec">Secretaries Cadre</option>
                            <option value="Info">Information and Public Relations Officers Cadre</option>
                            <option value="Legal">Legal Officers Cadre</option>
                            <option value="Secretarial">Secretarial Assistant/Data processing Officer Cadre</option>
                            <option value="Pharmacists">Pharmacists Cadre</option>
                            <option value="Nursing">Nursing Cadre</option>
                            <option value="Medical">Medical Doctor's Cadre</option>
                            <option value="Health">Health Technician's Cadre</option>
                            <option value="Radiographer">Radiographer's Cadre</option>
                            <option value="Bursary">Bursary Staff - Accountant's Cadre</option>
                            <option value="Executive Accounts">Executive Officers (Accounts) Cadre</option>
                            <option value="Internal">Internal Auditor's Cadre</option>
                            <option value="Stores">Stores Cadre</option>
                            <option value="Security">Security Officer Cadre</option>
                            <option value="Library">Library (Sub-Professional Staff) Cadre</option>
                            <option value="Bindery">Bindery Staff Cadre</option>
                            <option value="Teaching Farm">Teaching Farm Officers Cadre</option>
                            <option value="Premises">Premises/Housekeepers Cadre</option>
                            <option value="Catering">Catering Officers Cadre</option>
                            <option value="Computer">Computer Professional Cadre</option>
                            <option value="Teacher">Teachers Cadre</option>
                            <option value="Technologist">Technologist Cadre</option>
                            <option value="Lab">Laboratory Scientist Cadre</option>
                            <option value="Sports">Sports Cadre</option>
                            <option value="Estate">Estate, Works & Transport (Engineers) Cadre</option>
                            <option value="Maintenance">Maintenance Officers/Other Professionals Cadre</option>
                            <option value="Technician">Technician Cadre (Technical Officers)</option>
                            <option value="Motor">Motor/Tractor Drivers and Mechanics Cadre</option>
                            <option value="Environmental">Environmental/Public Health Officer/Community Health Education Worker
                                Cadre</option>
                        </select>
                        <select v-if="candidate.staffType == 'Junior Non-academic'" id="staffCadre" name="staffCadre" v-model="candidate.staffCadre"
                            style="width: 320px;" disabled>
                            <option value="Registry" selected>Registry Department (Clerical Cadre)</option>
                            <option value="Cleaner">Cleaner Cadre</option>
                            <option value="Secretarial">Secretarial Assistants (i.e. Typists) Cadre</option>
                            <option value="Computer">Computer Operator Cadre</option>
                            <option value="Audit">Audit Cadre</option>
                            <option value="Store">Store Cadre</option>
                            <option value="Accounts">Accounts Cadre</option>
                            <option value="Catering">Catering Cadre</option>
                            <option value="Halls">Halls of Residence</option>
                            <option value="Health">Health Services Department (Medical Records Cadre)</option>
                            <option value="Pharmacy">Pharmacy Assistant Cadre</option>
                            <option value="Health Assistant">Health Assitant Cadre</option>
                            <option value="Washerman">Washerman Cadre</option>
                            <option value="Library">Library Department</option>
                            <option value="Bindery">Bindery/Printing Cadre</option>
                            <option value="Audio">Audio-Visual Cadre</option>
                            <option value="Security">Security Department</option>
                            <option value="Environmental">Environmental Sciences (Technical Cadre)</option>
                            <option value="Engineering">Engineering, Science (Technical Cadre)</option>
                            <option value="Marine">Marine Engineering Department (Technician Cadre)</option>
                            <option value="Estate">Estate, Works and Transport Department (Labour/Gardener) Cadre</option>
                            <option value="Technical">Technical Cadre</option>
                            <option value="Drivers">Drivers Cadre</option>
                            <option value="Divers Mate">Drivers Mate Cadre</option>
                            <option value="Tractor">Tractor Drivers' Cadre</option>
                            <option value="Tractor Mate">Tractor Drivers' Mate Cadre</option>
                            <option value="Stores">Stores Cadre (Estate, Works and Transport Department)</option>
                            <option value="Store Attendant">Store Attendant (Estate, Works and Transport Department)</option>
                            <option value="Agriculture">Faculty of Agriculture (Technical Cadre)</option>
                            <option value="Labourer">Labourer Cadre (Faculty of Agriculture)</option>
                            <option value="Science">Science Laboratory Cadre</option>
                            <option value="Nursery">Nursery Attendants for the Staff School</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="container text-start px-4">
            <h6><b>Staff member assessment using ratings shown in notes. To be completed by the Supervisor (Immediate Boss) of the Staff.</b></h6>
        </div>
        <div class="text-start container mt-4 px-4 notes">
            <b>
                <div>NOTES:</div>
                <table style="width: 45%;" class="ms-5">
                    <tr>
                        <td>OUTSTANDING</td>
                        <td style="width: 15%;">A</td>
                        <td>5</td>
                    </tr>
                    <tr>
                        <td>VERY GOOD</td>
                        <td>B</td>
                        <td>4</td>
                    </tr>
                    <tr>
                        <td>GOOD</td>
                        <td>C</td>
                        <td>3</td>
                    </tr>
                    <tr>
                        <td>SATISFACTORY</td>
                        <td>D</td>
                        <td>2</td>
                    </tr>
                    <tr>
                        <td>UNSATISFACTORY</td>
                        <td>E</td>
                        <td>1</td>
                    </tr>
                </table>
            </b>
        </div>
        <div class="container px-4">
            <div>
                <div class="text-start container mt-4">
                    <div class="mb-3">1. Competence and understanding of the job.</div>
                    <div class="ms-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value=5
                                v-model="competence">
                            <label class="form-check-label" for="inlineRadio1">Outstanding</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value=4
                                v-model="competence">
                            <label class="form-check-label" for="inlineRadio2">Very Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio3" value=3
                                v-model="competence">
                            <label class="form-check-label" for="inlineRadio3">Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio4" value=2
                                v-model="competence">
                            <label class="form-check-label" for="inlineRadio4">Satisfactory</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio5" value=1
                                v-model="competence">
                            <label class="form-check-label" for="inlineRadio5">Unsatisfactory</label>
                        </div>
                    </div>
                </div>
                <div class="text-start container mt-4">
                    <div class="mb-3">2. Motivation and industry</div>
                    <div class="ms-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions2" id="inlineRadio6" value=5
                                v-model="motivation">
                            <label class="form-check-label" for="inlineRadio6">Outstanding</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions2" id="inlineRadio7" value=4
                                v-model="motivation">
                            <label class="form-check-label" for="inlineRadio7">Very Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions2" id="inlineRadio8" value=3
                                v-model="motivation">
                            <label class="form-check-label" for="inlineRadio8">Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions2" id="inlineRadio9" value=2
                                v-model="motivation">
                            <label class="form-check-label" for="inlineRadio9">Satisfactory</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions2" id="inlineRadio10" value=1
                                v-model="motivation">
                            <label class="form-check-label" for="inlineRadio10">Unsatisfactory</label>
                        </div>
                    </div>
                </div>
                <div class="text-start container mt-4">
                    <div class="mb-3">3. Integrity and Reliability</div>
                    <div class="ms-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions5" id="inlineRadio11" value=5
                                v-model="integrity">
                            <label class="form-check-label" for="inlineRadio21">Outstanding</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions5" id="inlineRadio12" value=4
                                v-model="integrity">
                            <label class="form-check-label" for="inlineRadio22">Very Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions5" id="inlineRadio13" value=3
                                v-model="integrity">
                            <label class="form-check-label" for="inlineRadio23">Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions5" id="inlineRadio14" value=2
                                v-model="integrity">
                            <label class="form-check-label" for="inlineRadio24">Satisfactory</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions5" id="inlineRadio15" value=1
                                v-model="integrity">
                            <label class="form-check-label" for="inlineRadio25">Unsatisfactory</label>
                        </div>
                    </div>
                </div>
                <div class="text-start container mt-4">
                    <div class="mb-3">4. Initiative, creative ability and concern to produce result</div>
                    <div class="ms-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions3" id="inlineRadio16" value=5
                                v-model="initiative">
                            <label class="form-check-label" for="inlineRadio11">Outstanding</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions3" id="inlineRadio17" value=4
                                v-model="initiative">
                            <label class="form-check-label" for="inlineRadio12">Very Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions3" id="inlineRadio18" value=3
                                v-model="initiative">
                            <label class="form-check-label" for="inlineRadio13">Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions3" id="inlineRadio19" value=2
                                v-model="initiative">
                            <label class="form-check-label" for="inlineRadio14">Satisfactory</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions3" id="inlineRadio20" value=1
                                v-model="initiative">
                            <label class="form-check-label" for="inlineRadio15">Unsatisfactory</label>
                        </div>
                    </div>
                </div>
                <div class="text-start container mt-4">
                    <div class="mb-3">5. Punctuality and staying on the job</div>
                    <div class="ms-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions13" id="inlineRadio21" value=5
                                v-model="punctuality">
                            <label class="form-check-label" for="inlineRadio70">Outstanding</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions13" id="inlineRadio22" value=4
                                v-model="punctuality">
                            <label class="form-check-label" for="inlineRadio71">Very Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions13" id="inlineRadio23" value=3
                                v-model="punctuality">
                            <label class="form-check-label" for="inlineRadio72">Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions13" id="inlineRadio24" value=2
                                v-model="punctuality">
                            <label class="form-check-label" for="inlineRadio73">Satisfactory</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions13" id="inlineRadio25" value=1
                                v-model="punctuality">
                            <label class="form-check-label" for="inlineRadio74">Unsatisfactory</label>
                        </div>
                    </div>
                </div>
                <div class="text-start container mt-4">
                    <div class="mb-3">6. Ability to communicate and write</div>
                    <div class="ms-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions14" id="inlineRadio26" value=5
                                v-model="abilityCommunicate">
                            <label class="form-check-label" for="inlineRadio75">Outstanding</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions14" id="inlineRadio27" value=4
                                v-model="abilityCommunicate">
                            <label class="form-check-label" for="inlineRadio76">Very Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions14" id="inlineRadio28" value=3
                                v-model="abilityCommunicate">
                            <label class="form-check-label" for="inlineRadio77">Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions14" id="inlineRadio29" value=2
                                v-model="abilityCommunicate">
                            <label class="form-check-label" for="inlineRadio78">Satisfactory</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions14" id="inlineRadio30" value=1
                                v-model="abilityCommunicate">
                            <label class="form-check-label" for="inlineRadio79">Unsatisfactory</label>
                        </div>
                    </div>
                </div>
                <div class="text-start container mt-4">
                    <div class="mb-3">7. Group relations and co-operation with others at work</div>
                    <div class="ms-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions15" id="inlineRadio31" value=5
                                v-model="cooperativeness">
                            <label class="form-check-label" for="inlineRadio80">Outstanding</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions15" id="inlineRadio32" value=4
                                v-model="cooperativeness">
                            <label class="form-check-label" for="inlineRadio81">Very Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions15" id="inlineRadio33" value=3
                                v-model="cooperativeness">
                            <label class="form-check-label" for="inlineRadio82">Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions15" id="inlineRadio34" value=2
                                v-model="cooperativeness">
                            <label class="form-check-label" for="inlineRadio83">Satisfactory</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions15" id="inlineRadio35" value=1
                                v-model="cooperativeness">
                            <label class="form-check-label" for="inlineRadio84">Unsatisfactory</label>
                        </div>
                    </div>
                </div>
                <div class="text-start container mt-4">
                    <div class="mb-3">8. Understanding of the University System</div>
                    <div class="ms-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions16" id="inlineRadio36" value=5
                                v-model="understanding">
                            <label class="form-check-label" for="inlineRadio85">Outstanding</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions16" id="inlineRadio37" value=4
                                v-model="understanding">
                            <label class="form-check-label" for="inlineRadio86">Very Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions16" id="inlineRadio38" value=3
                                v-model="understanding">
                            <label class="form-check-label" for="inlineRadio87">Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions16" id="inlineRadio39" value=2
                                v-model="understanding">
                            <label class="form-check-label" for="inlineRadio88">Satisfactory</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions16" id="inlineRadio40" value=1
                                v-model="understanding">
                            <label class="form-check-label" for="inlineRadio89">Unsatisfactory</label>
                        </div>
                    </div>
                </div>
                <div class="text-start container mt-4">
                    <div class="mb-3">9. Ability to take on additional responsibilities</div>
                    <div class="ms-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions17" id="inlineRadio41" value=5
                                v-model="abilityResponsibility">
                            <label class="form-check-label" for="inlineRadio90">Outstanding</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions17" id="inlineRadio42" value=4
                                v-model="abilityResponsibility">
                            <label class="form-check-label" for="inlineRadio91">Very Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions17" id="inlineRadio43" value=3
                                v-model="abilityResponsibility">
                            <label class="form-check-label" for="inlineRadio92">Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions17" id="inlineRadio44" value=2
                                v-model="abilityResponsibility">
                            <label class="form-check-label" for="inlineRadio93">Satisfactory</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions17" id="inlineRadio45" value=1
                                v-model="abilityResponsibility">
                            <label class="form-check-label" for="inlineRadio94">Unsatisfactory</label>
                        </div>
                    </div>
                </div>
                <div class="text-start container mt-4">
                    <div class="mb-3">10. Ability to work un-supervised</div>
                    <div class="ms-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions18" id="inlineRadio46" value=5
                                v-model="abilityUnsupervised">
                            <label class="form-check-label" for="inlineRadio95">Outstanding</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions18" id="inlineRadio47" value=4
                                v-model="abilityUnsupervised">
                            <label class="form-check-label" for="inlineRadio96">Very Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions18" id="inlineRadio48" value=3
                                v-model="abilityUnsupervised">
                            <label class="form-check-label" for="inlineRadio97">Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions18" id="inlineRadio49" value=2
                                v-model="abilityUnsupervised">
                            <label class="form-check-label" for="inlineRadio98">Satisfactory</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions18" id="inlineRadio50" value=1
                                v-model="abilityUnsupervised">
                            <label class="form-check-label" for="inlineRadio99">Unsatisfactory</label>
                        </div>
                    </div>
                </div>
                <div class="text-start container mt-4">
                    <div class="mb-3">11. Maturity and judgement</div>
                    <div class="ms-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions19" id="inlineRadio51" value=5
                                v-model="maturity">
                            <label class="form-check-label" for="inlineRadio96">Outstanding</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions19" id="inlineRadio52" value=4
                                v-model="maturity">
                            <label class="form-check-label" for="inlineRadio97">Very Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions19" id="inlineRadio53" value=3
                                v-model="maturity">
                            <label class="form-check-label" for="inlineRadio98">Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions19" id="inlineRadio54" value=2
                                v-model="maturity">
                            <label class="form-check-label" for="inlineRadio99">Satisfactory</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions19" id="inlineRadio55" value=1
                                v-model="maturity">
                            <label class="form-check-label" for="inlineRadio100">Unsatisfactory</label>
                        </div>
                    </div>
                </div>
                <div class="text-start container mt-4">
                    <div class="mb-3">12. Special skill in some area</div>
                    <div class="ms-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions100" id="inlineRadio56" value=5
                                v-model="specialSkill">
                            <label class="form-check-label" for="inlineRadio96">Outstanding</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions100" id="inlineRadio57" value=4
                                v-model="specialSkill">
                            <label class="form-check-label" for="inlineRadio97">Very Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions100" id="inlineRadio58" value=3
                                v-model="specialSkill">
                            <label class="form-check-label" for="inlineRadio98">Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions100" id="inlineRadio59" value=2
                                v-model="specialSkill">
                            <label class="form-check-label" for="inlineRadio99">Satisfactory</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions100" id="inlineRadio60" value=1
                                v-model="specialSkill">
                            <label class="form-check-label" for="inlineRadio100">Unsatisfactory</label>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="candidate.staffType == 'Senior Non-academic'">
                <div class="text-start container mt-4">
                    <div class="mb-3">13. Organising ability and staff management</div>
                    <div class="ms-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOption" id="inlineRadio61" value=5
                                v-model="organising">
                            <label class="form-check-label" for="inlineRadio1">Outstanding</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOption" id="inlineRadio62" value=4
                                v-model="organising">
                            <label class="form-check-label" for="inlineRadio2">Very Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOption" id="inlineRadio63" value=3
                                v-model="organising">
                            <label class="form-check-label" for="inlineRadio3">Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOption" id="inlineRadio64" value=2
                                v-model="organising">
                            <label class="form-check-label" for="inlineRadio4">Satisfactory</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOption" id="inlineRadio65" value=1
                                v-model="organising">
                            <label class="form-check-label" for="inlineRadio5">Unsatisfactory</label>
                        </div>
                    </div>
                </div>
                <div class="text-start container mt-4">
                    <div class="mb-3">14. Responsiveness to the demands of the job</div>
                    <div class="ms-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOption2" id="inlineRadio66" value=5
                                v-model="responsiveness">
                            <label class="form-check-label" for="inlineRadio6">Outstanding</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOption2" id="inlineRadio67" value=4
                                v-model="responsiveness">
                            <label class="form-check-label" for="inlineRadio7">Very Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOption2" id="inlineRadio68" value=3
                                v-model="responsiveness">
                            <label class="form-check-label" for="inlineRadio8">Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOption2" id="inlineRadio69" value=2
                                v-model="responsiveness">
                            <label class="form-check-label" for="inlineRadio9">Satisfactory</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOption2" id="inlineRadio70" value=1
                                v-model="responsiveness">
                            <label class="form-check-label" for="inlineRadio10">Unsatisfactory</label>
                        </div>
                    </div>
                </div>
                <div class="text-start container mt-4">
                    <div class="mb-3">15. Standard of written work</div>
                    <div class="ms-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOption3" id="inlineRadio71" value=5
                                v-model="standard">
                            <label class="form-check-label" for="inlineRadio11">Outstanding</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOption3" id="inlineRadio72" value=4
                                v-model="standard">
                            <label class="form-check-label" for="inlineRadio12">Very Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOption3" id="inlineRadio73" value=3
                                v-model="standard">
                            <label class="form-check-label" for="inlineRadio13">Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOption3" id="inlineRadio74" value=2
                                v-model="standard">
                            <label class="form-check-label" for="inlineRadio14">Satisfactory</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOption3" id="inlineRadio75" value=1
                                v-model="standard">
                            <label class="form-check-label" for="inlineRadio15">Unsatisfactory</label>
                        </div>
                    </div>
                </div>
                <div class="text-start container mt-4">
                    <div class="mb-3">16. Relationship with other staff</div>
                    <div class="ms-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions4" id="inlineRadio76" value=5
                                v-model="relationship">
                            <label class="form-check-label" for="inlineRadio16">Outstanding</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions4" id="inlineRadio77" value=4
                                v-model="relationship">
                            <label class="form-check-label" for="inlineRadio17">Very Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions4" id="inlineRadio78" value=3
                                v-model="relationship">
                            <label class="form-check-label" for="inlineRadio18">Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions4" id="inlineRadio79" value=2
                                v-model="relationship">
                            <label class="form-check-label" for="inlineRadio19">Satisfactory</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions4" id="inlineRadio80" value=1
                                v-model="relationship">
                            <label class="form-check-label" for="inlineRadio20">Unsatisfactory</label>
                        </div>
                    </div>
                </div>
                <div class="text-start container mt-4">
                    <div class="mb-3">17. Productivity</div>
                    <div class="ms-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOption5" id="inlineRadio81" value=5
                                v-model="productivity">
                            <label class="form-check-label" for="inlineRadio21">Outstanding</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOption5" id="inlineRadio82" value=4
                                v-model="productivity">
                            <label class="form-check-label" for="inlineRadio22">Very Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOption5" id="inlineRadio83" value=3
                                v-model="productivity">
                            <label class="form-check-label" for="inlineRadio23">Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOption5" id="inlineRadio84" value=2
                                v-model="productivity">
                            <label class="form-check-label" for="inlineRadio24">Satisfactory</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOption5" id="inlineRadio85" value=1
                                v-model="productivity">
                            <label class="form-check-label" for="inlineRadio25">Unsatisfactory</label>
                        </div>
                    </div>
                </div>
                <div class="text-start container mt-4">
                    <div class="mb-3">18. Thoroughness in handling job</div>
                    <div class="ms-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions6" id="inlineRadio86" value=5
                                v-model="thoroughness">
                            <label class="form-check-label" for="inlineRadio26">Outstanding</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions6" id="inlineRadio87" value=4
                                v-model="thoroughness">
                            <label class="form-check-label" for="inlineRadio27">Very Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions6" id="inlineRadio88" value=3
                                v-model="thoroughness">
                            <label class="form-check-label" for="inlineRadio28">Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions6" id="inlineRadio89" value=2
                                v-model="thoroughness">
                            <label class="form-check-label" for="inlineRadio29">Satisfactory</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions6" id="inlineRadio90" value=1
                                v-model="thoroughness">
                            <label class="form-check-label" for="inlineRadio30">Unsatisfactory</label>
                        </div>
                    </div>
                </div>
                <div class="text-start container mt-4">
                    <div class="mb-3">19. Supervisory ability</div>
                    <div class="ms-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions7" id="inlineRadio91" value=5
                                v-model="supervisory">
                            <label class="form-check-label" for="inlineRadio31">Outstanding</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions7" id="inlineRadio92" value=4
                                v-model="supervisory">
                            <label class="form-check-label" for="inlineRadio32">Very Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions7" id="inlineRadio93" value=3
                                v-model="supervisory">
                            <label class="form-check-label" for="inlineRadio33">Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions7" id="inlineRadio94" value=2
                                v-model="supervisory">
                            <label class="form-check-label" for="inlineRadio34">Satisfactory</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions7" id="inlineRadio95" value=1
                                v-model="supervisory">
                            <label class="form-check-label" for="inlineRadio35">Unsatisfactory</label>
                        </div>
                    </div>
                </div>
                <div class="text-start container mt-4">
                    <div class="mb-3">20. Intellectual ability</div>
                    <div class="ms-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions8" id="inlineRadio96" value=5
                                v-model="intellectual">
                            <label class="form-check-label" for="inlineRadio36">Outstanding</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions8" id="inlineRadio97" value=4
                                v-model="intellectual">
                            <label class="form-check-label" for="inlineRadio37">Very Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions8" id="inlineRadio98" value=3
                                v-model="intellectual">
                            <label class="form-check-label" for="inlineRadio38">Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions8" id="inlineRadio99" value=2
                                v-model="intellectual">
                            <label class="form-check-label" for="inlineRadio39">Satisfactory</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions8" id="inlineRadio100" value=1
                                v-model="intellectual">
                            <label class="form-check-label" for="inlineRadio40">Unsatisfactory</label>
                        </div>
                    </div>
                </div>
                <div class="text-start container mt-4">
                    <div class="mb-3">21. Planning/foresight and co-operation</div>
                    <div class="ms-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions9" id="inlineRadio101" value=5
                                v-model="planning">
                            <label class="form-check-label" for="inlineRadio41">Outstanding</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions9" id="inlineRadio102" value=4
                                v-model="planning">
                            <label class="form-check-label" for="inlineRadio42">Very Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions9" id="inlineRadio103" value=3
                                v-model="planning">
                            <label class="form-check-label" for="inlineRadio43">Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions9" id="inlineRadio104" value=2
                                v-model="planning">
                            <label class="form-check-label" for="inlineRadio44">Satisfactory</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions9" id="inlineRadio105" value=1
                                v-model="planning">
                            <label class="form-check-label" for="inlineRadio45">Unsatisfactory</label>
                        </div>
                    </div>
                </div>
                <div class="text-start container mt-4">
                    <div class="mb-3">22. Leadership</div>
                    <div class="ms-3">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions10" id="inlineRadio106" value=5
                                v-model="leadership">
                            <label class="form-check-label" for="inlineRadio46">Outstanding</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions10" id="inlineRadio107" value=4
                                v-model="leadership">
                            <label class="form-check-label" for="inlineRadio47">Very Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions10" id="inlineRadio108" value=3
                                v-model="leadership">
                            <label class="form-check-label" for="inlineRadio48">Good</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions10" id="inlineRadio109" value=2
                                v-model="leadership">
                            <label class="form-check-label" for="inlineRadio49">Satisfactory</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions10" id="inlineRadio110" value=1
                                v-model="leadership">
                            <label class="form-check-label" for="inlineRadio50">Unsatisfactory</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container px-5">
        <div class="my-5 text-start"><b>Overall Assessment of Performance: {{ total }}</b></div>
        <div class="d-flex pb-5 text-start">
            <button @click="saveSection()" type="button" class="btn btn-success me-3">Save & Continue</button>
        </div>
    </div>
</template>
<script>
import DataService from '../../services/dataservice';

export default {
    name: 'nonacademicAssessorSection1',
    emits: ['toggleLoader'],
    data() {
        return {
            candidate: {},
            competence: 0,
            motivation: 0,
            integrity: 0,
            initiative: 0,
            punctuality: 0,
            abilityCommunicate: 0,
            cooperativeness: 0,
            understanding: 0,
            abilityResponsibility: 0,
            abilityUnsupervised: 0,
            maturity: 0,
            specialSkill: 0,
            organising: 0,
            responsiveness: 0,
            standard: 0,
            relationship: 0,
            productivity: 0,
            thoroughness: 0,
            supervisory: 0,
            intellectual: 0,
            planning: 0,
            leadership: 0,
            itemRatings: [
                { rating: 'Outstanding', value: 5 },
                { rating: 'Very Good', value: 4 },
                { rating: 'Good', value: 3 },
                { rating: 'Satisfactory', value: 2 },
                { rating: 'Unsatisfactory', value: 1 }
            ]
        }
    },
    computed: {
        total() {
            return Number(this.competence) + Number(this.motivation) + Number(this.integrity) +
                Number(this.initiative) + Number(this.punctuality) + Number(this.abilityCommunicate) +
                Number(this.cooperativeness) + Number(this.understanding) + Number(this.abilityResponsibility) +
                Number(this.abilityUnsupervised) + Number(this.maturity) + Number(this.specialSkill) +
                Number(this.organising) + Number(this.responsiveness) + Number(this.standard) +
                Number (this.relationship) + Number(this.productivity) + Number(this.thoroughness) + 
                Number(this.supervisory) + Number(this.intellectual) + Number(this.planning) + 
                Number(this.leadership)
        }
    },
    mounted() {
        this.setData()
    },
    methods: {
        async saveSection() {
            this.$emit('toggleLoader');

            var dataDetails = {
                competence: this.competence,
                motivation: this.motivation,
                integrity: this.integrity,
                initiative: this.initiative,
                punctuality: this.punctuality,
                abilityCommunicate: this.abilityCommunicate,
                cooperativeness: this.cooperativeness,
                understanding: this.understanding,
                abilityResponsibility: this.abilityResponsibility,
                abilityUnsupervised: this.abilityUnsupervised,
                maturity: this.maturity,
                specialSkill: this.specialSkill,
                organising: this.organising,
                responsiveness: this.responsiveness,
                standard: this.standard,
                relationship: this.relationship,
                productivity: this.productivity,
                thoroughness: this.thoroughness,
                supervisory: this.supervisory,
                intellectual: this.intellectual,
                planning: this.planning,
                leadership: this.leadership,
                overall: this.total
            }

            const candidate = await DataService.saveData(dataDetails)

            this.$emit('toggleLoader');

            if (candidate) {
                this.candidate = candidate

                this.$router.push("/nonacademicassessorsection3")
            }
        },
        async setData() {
            this.$emit('toggleLoader');

            const candidate = await DataService.getCandidate(JSON.parse(window.localStorage['user'])._id);
            
            if (candidate) {
                this.candidate = candidate ? candidate : {}
                this.competence = candidate.competence ? candidate.competence : 0
                this.motivation = candidate.motivation ? candidate.motivation : 0
                this.integrity = candidate.integrity ? candidate.integrity : 0
                this.initiative = candidate.initiative ? candidate.initiative : 0
                this.punctuality = candidate.punctuality ? candidate.punctuality : 0
                this.abilityCommunicate = candidate.abilityCommunicate ? candidate.abilityCommunicate : 0
                this.cooperativeness = candidate.cooperativeness ? candidate.cooperativeness : 0
                this.understanding = candidate.understanding ? candidate.understanding : 0
                this.abilityResponsibility = candidate.abilityResponsibility ? candidate.abilityResponsibility : 0
                this.abilityUnsupervised = candidate.abilityUnsupervised ? candidate.abilityUnsupervised : 0
                this.maturity = candidate.maturity ? candidate.maturity : 0
                this.specialSkill = candidate.specialSkill ? candidate.specialSkill : 0
                this.organising = candidate.organising ? candidate.organising : 0
                this.responsiveness = candidate.responsiveness ? candidate.responsiveness : 0
                this.standard = candidate.standard ? candidate.standard : 0
                this.relationship = candidate.relationship ? candidate.relationship : 0
                this.productivity = candidate.productivity ? candidate.productivity : 0
                this.thoroughness = candidate.thoroughness ? candidate.thoroughness : 0
                this.supervisory = candidate.supervisory ? candidate.supervisory : 0
                this.intellectual = candidate.intellectual ? candidate.intellectual : 0
                this.planning = candidate.planning ? candidate.planning : 0
                this.leadership = candidate.leadership ? candidate.leadership : 0
            }
        
            this.$emit('toggleLoader');
        },
    }
}
</script>